/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractPaymentResponseDto } from '../../models/sales-contract-payment-response-dto';
import { SalesContractPaymentUpdateDto } from '../../models/sales-contract-payment-update-dto';

export interface ContractPaymentsControllerUpdate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the contract payment to update.
 */
  id: string;
      body: SalesContractPaymentUpdateDto
}

export function contractPaymentsControllerUpdate(http: HttpClient, rootUrl: string, params: ContractPaymentsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractPaymentResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contractPaymentsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContractPaymentResponseDto>;
    })
  );
}

contractPaymentsControllerUpdate.PATH = '/o2-sales/contract-payments/{tenant}/{id}';
